import {DetectionNotificationProps} from "@/notification/interfaces";
import Consumer from "@/core/interfaces/consumers/Consumer";
import {Program} from "@/program/interfaces/Program";

const NotificationProgramService = () => {
    return {
        /**
         * Group the customer and his beneficiaries into one array.
         *
         * @param customer
         */
        consumers: (customer: DetectionNotificationProps["customer"]): Consumer[] => {
            if (!customer) {
                return [];
            }

            return [
                customer,
                ...(customer.beneficiaries ?? [])
            ];
        },

        /**
         * Determine if the program should not be hidden in the notification.
         */
        programNotHidden: (program: any): boolean => {
            return !(program.feedbacks?.filter(feedback => feedback.hide_notification).length > 0);
        },

        /**
         * Get the consumer programs that should be displayed in the notification.
         *
         * @param customer The detected customer.
         * @param selectedConsumerKey When set, only that consumer's programs are kept
         *                            (beneficiary ↔ insured customer switch).
         */
        consumerPrograms(customer, selectedConsumerKey?: string | null): Record<string, any> {
            const consumers = this.consumers(customer)
                .filter((consumer) => !selectedConsumerKey || consumer.key === selectedConsumerKey);

            return consumers.reduce((acc, consumer) => {
                if (consumer.programs?.length > 0) {
                    acc[consumer.key] = consumer.programs
                        .filter(program => this.programNotHidden(program))
                        .sort((a: Program, b: Program) => {
                            return (b.next_step?.index || 0) - (a.next_step?.index || 0);
                        });
                }

                return acc;
            }, {});
        }
    };
};

export default NotificationProgramService();
